import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
} from 'react-router-dom';

import ModalActionCreator from 'action_creators/modal';

import Header from './header/Header';
import Certificates from './certificates/Certificates';
import PricingModal from './pricing_modal/PricingModal';
import Checkout from './checkout/Checkout';

import DATA from './data';
import './index.scss';
import Confirmation from './confirmation/Confirmation';

class GiftCertificates extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checkoutData: null,
      checkoutFormData: null,
    };
  }

  submitPricingSelection = (selectionData) => {
    const { tourId, selections } = selectionData;
    const tour = DATA.tours.find((t) => t.id === tourId);
    const pricingTypes = tour.pricing.types;

    // Pricing Calculation =====
    const pricing = {};
    // Subtotal and units
    pricing.units = [];
    pricing.subtotal = 0;
    Object.keys(selections).forEach((typeId) => {
      const quantity = selections[typeId];
      const pricingType = pricingTypes.find((s) => s.id == typeId);
      const { price } = pricingType;
      pricing.subtotal += quantity * price;
      pricing.units.push({ name: `${pricingType.name}`, quantity, price });
    });

    // Service Fee (10%)
    // pricing.serviceFee = pricing.subtotal * 0.1;
    // Total
    // pricing.total = pricing.subtotal + pricing.serviceFee;
    pricing.total = pricing.subtotal;
    // =====

    const checkoutData = { ...selectionData, tour, pricing };
    this.setState({
      checkoutData,
    });
  };

  submitCheckout = (checkoutFormData) => {
    this.setState({ checkoutFormData });
    window.scrollTo(0, 0);
  };

  renderHeader = () => {
    const { color, logo, name } = this.props.header_data;
    const bgStyle = { backgroundColor: color };

    let content = name;
    if (logo) {
      content = (
        <img
          className="headerLogo"
          src={logo}
          alt={name}
          onClick={() => location.reload()}
        />
      );
    }

    return (
      <div className="desktopHeader" style={bgStyle}>
        {content}
      </div>
    );
  };

  renderCheckout = () => {
    return (
      <Checkout
        checkoutData={this.state.checkoutData}
        submitCheckout={this.submitCheckout}
      />
    );
  };

  renderConfirmation = () => {
    return (
      <Confirmation
        checkoutData={this.state.checkoutData}
        checkoutFormData={this.state.checkoutFormData}
      />
    );
  };

  render() {
    const guideSlug = this.props.guide_slug;

    return (
      <div>
        <Router>
          <div>
            <Route
              path="/:guide_slug/gift_certificates"
              render={(props) => (
                <Header {...props} headerData={this.props.header_data} />
              )}
            />

            <Route
              exact
              path="/:guide_slug/gift_certificates"
              render={(props) => (
                <Certificates
                  {...props}
                  submitPricingSelection={this.submitPricingSelection}
                />
              )}
            />

            <Route
              exact
              path="/:guide_slug/gift_certificates/checkout"
              render={(props) => (
                <Checkout
                  {...props}
                  checkoutData={this.state.checkoutData}
                  submitCheckout={this.submitCheckout}
                />
              )}
            />

            <Route
              exact
              path="/:guide_slug/gift_certificates/confirmation"
              render={(props) => (
                <Confirmation
                  {...props}
                  checkoutData={this.state.checkoutData}
                  checkoutFormData={this.state.checkoutFormData}
                />
              )}
            />
          </div>
        </Router>
      </div>
    );
  }
}

export default GiftCertificates;
